import { Card, Col, Row, Tag, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph } = Typography

const CGUPage = () => {
  return (
    <Card>
      <Row>
        <Col span={24}>
          <Title level={3}>CONDITIONS GÉNÉRALES D&apos;UTILISATION (CGU)</Title>
          <Paragraph>
            <Tag color="pink">Version mise à jour au 28/12/2024</Tag>
          </Paragraph>

          <Paragraph>
            <strong>1.1 Objet</strong>
            <br />
            Les présentes Conditions Générales d&apos;Utilisation (ci-après
            « CGU ») régissent les conditions dans lesquelles la société [Nom de
            la société] (ci-après « l’Éditeur ») met à la disposition de toute
            personne (ci-après « l’Utilisateur ») la plateforme Echow (ci-après
            « la Plateforme ») et l’ensemble des services qui y sont proposés
            (ci-après « les Services »).
          </Paragraph>
          <Paragraph>
            <strong>1.2 Acceptation</strong>
            <br />
            L’accès et l’utilisation de la Plateforme impliquent l’acceptation
            entière et sans réserve des présentes CGU. L’Éditeur se réserve la
            possibilité de modifier ou de mettre à jour les présentes CGU à tout
            moment. Il appartient à l’Utilisateur de consulter régulièrement la
            dernière version en vigueur.
          </Paragraph>

          {/* ARTICLE 2 */}
          <Title level={4}>
            ARTICLE 2 – PRÉSENTATION DE LA PLATEFORME ECHOW
          </Title>
          <Paragraph>
            <strong>2.1 Description générale</strong>
            <br />
            Echow est une plateforme en ligne disponible partout à travers le
            monde. Elle permet de connecter votre compte Instagram à une
            Automation afin de détecter automatiquement chaque mention en Story.
            Vous pouvez configurer des messages personnalisés (texte, vocal,
            vidéo ou image) qui sont envoyés de manière automatique, tout en
            simulant un comportement humain grâce à des délais paramétrables.
            Valorisé et surpris par votre réactivité, l’utilisateur s’engage
            davantage avec votre compte, boostant votre visibilité et
            transformant vos visiteurs en followers.
          </Paragraph>

          <Paragraph>
            <strong>2.2 Modalités d&apos;accès</strong>
            <br />
            L’accès aux fonctionnalités nécessite la création d’un compte.
            L’Utilisateur s’engage alors à fournir des informations exactes, à
            jour et complètes, et à respecter les présentes CGU.
          </Paragraph>

          {/* ARTICLE 3 */}
          <Title level={4}>ARTICLE 3 – MENTIONS LÉGALES</Title>
          <Paragraph>
            Les mentions légales complètes de la société Supplément Bacon sont
            disponibles et consultables dans un document distinct accessible à
            l’adresse suivante&nbsp;:
            <strong>
              <Link to="/legal/legal-notice">Mentions légales</Link>.
            </strong>
          </Paragraph>
          <Paragraph>
            L’Utilisateur est invité à prendre connaissance de ces informations,
            qui font partie intégrante de son engagement contractuel envers
            l’Éditeur.
          </Paragraph>

          {/* ARTICLE 4 */}
          <Title level={4}>ARTICLE 4 – DÉFINITIONS</Title>
          <Paragraph>
            &ndash; <strong>Éditeur</strong> : la société Supplément Bacon qui
            édite et exploite la Plateforme Echow.
            <br />
            &ndash; <strong>Plateforme</strong> : ensemble du site web, des
            applications, des pages et fonctionnalités mises à disposition par
            l’Éditeur, sous l’appellation « Echow ».
            <br />
            &ndash; <strong>Services</strong> : toute fonctionnalité proposée
            aux Utilisateurs par l’Éditeur sur la Plateforme (mise en relation,
            partage de contenu, messagerie, etc.).
            <br />
            &ndash; <strong>Utilisateur</strong> : toute personne (physique ou
            morale) qui accède à la Plateforme, qu’elle dispose ou non d’un
            compte utilisateur.
            <br />
            &ndash; <strong>Contenu</strong> : tout élément, texte, image,
            vidéo, information ou donnée, publié par l’Éditeur ou par
            l’Utilisateur sur la Plateforme.
          </Paragraph>

          {/* ARTICLE 5 */}
          <Title level={4}>ARTICLE 5 – CRÉATION DE COMPTE ET SÉCURITÉ</Title>
          <Paragraph>
            <strong>5.1 Inscription</strong>
            <br />
            Pour bénéficier pleinement des Services, l’Utilisateur peut être
            amené à créer un compte, en remplissant les champs requis (nom,
            prénom, adresse e-mail, etc.). L’Utilisateur garantit la véracité et
            l’exactitude des informations communiquées et s’engage à les mettre
            à jour en cas de modification.
          </Paragraph>
          <Paragraph>
            <strong>5.2 Identifiants et confidentialité</strong>
            <br />
            Les identifiants de connexion (nom d’utilisateur, mot de passe) sont
            personnels, confidentiels et incessibles. L’Utilisateur est seul
            responsable de la préservation et de la confidentialité de ses
            identifiants et de toute activité effectuée sous ces identifiants.
          </Paragraph>
          <Paragraph>
            <strong>5.3 Responsabilité de l’Utilisateur</strong>
            <br />
            Toute utilisation des Services, réalisation d’actions ou publication
            de Contenu via le compte de l’Utilisateur est réputée avoir été
            effectuée par ce dernier. En cas de soupçon d’accès non autorisé ou
            de perte des identifiants, l’Utilisateur doit en informer sans délai
            l’Éditeur afin de prendre les mesures adéquates (réinitialisation,
            suspension, etc.).
          </Paragraph>

          {/* ARTICLE 6 */}
          <Title level={4}>ARTICLE 6 – UTILISATION DE LA PLATEFORME</Title>
          <Paragraph>
            <strong>6.1 Règles de conduite</strong>
            <br />
            L’Utilisateur s’engage à&nbsp;:
          </Paragraph>
          <Paragraph>
            &ndash; Respecter les lois et règlements en vigueur&nbsp;;
            <br />
            &ndash; Ne pas publier de Contenu illicite, diffamatoire, injurieux,
            harcelant, pornographique, ou portant atteinte aux droits de
            tiers&nbsp;;
            <br />
            &ndash; Respecter la vie privée, l’image et la réputation
            d’autrui&nbsp;;
            <br />
            &ndash; Ne pas détourner l’usage normal de la Plateforme, notamment
            en la surchargant (attaques, spams, tentatives de piratage, etc.).
          </Paragraph>
          <Paragraph>
            <strong>6.2 Propriété du Contenu publié par l’Utilisateur</strong>
            <br />
            En publiant du Contenu sur la Plateforme, l’Utilisateur déclare et
            garantit disposer de tous les droits nécessaires et accorde à
            l’Éditeur une licence mondiale, non-exclusive et gratuite pour
            l’utilisation, la reproduction, la représentation, l’adaptation et
            la diffusion du Contenu, dans le respect de la réglementation
            applicable.
          </Paragraph>
          <Paragraph>
            <strong>6.3 Modération</strong>
            <br />
            L’Éditeur se réserve le droit de modérer, supprimer ou suspendre
            tout Contenu manifestement illicite, non conforme aux présentes CGU
            ou susceptible de porter atteinte aux droits d’autrui, et ce, sans
            préavis.
          </Paragraph>

          {/* ARTICLE 7 */}
          <Title level={4}>ARTICLE 7 – PROPRIÉTÉ INTELLECTUELLE</Title>
          <Paragraph>
            <strong>7.1 Éléments de la Plateforme</strong>
            <br />
            Les marques, logos, graphismes, photographies, animations, vidéos et
            textes présents sur la Plateforme, à l’exception du Contenu publié
            par les Utilisateurs, sont la propriété exclusive de l’Éditeur ou de
            ses partenaires. Toute reproduction, adaptation, diffusion ou
            exploitation non autorisée est strictement interdite.
          </Paragraph>
          <Paragraph>
            <strong>7.2 Licence concédée à l’Éditeur</strong>
            <br />
            L’Utilisateur conserve l’entière propriété du Contenu qu’il publie.
            Toutefois, en publiant un Contenu sur la Plateforme, il concède à
            l’Éditeur, pour la durée légale de protection des droits, une
            licence non-exclusive d’utilisation, de reproduction et de
            représentation à des fins de fonctionnement, de promotion et
            d’amélioration de la Plateforme.
          </Paragraph>

          {/* ARTICLE 8 */}
          <Title level={4}>ARTICLE 8 – DONNÉES PERSONNELLES ET COOKIES</Title>
          <Paragraph>
            <strong>8.1 Collecte et traitement</strong>
            <br />
            L’Éditeur peut être amené à collecter et traiter certaines données
            personnelles de l’Utilisateur (nom, prénom, email, etc.) dans le
            cadre de l’utilisation de la Plateforme. Ces traitements sont
            effectués conformément au Règlement Général sur la Protection des
            Données (RGPD) et à la loi Informatique et Libertés.
            <br />
            Pour plus d’informations sur la collecte et le traitement des
            données, veuillez consulter notre&nbsp;
            <strong>
              <Link to="/legal/data-privacy-policy">
                Politique de Confidentialité
              </Link>
            </strong>
            .
          </Paragraph>
          <Paragraph>
            <strong>8.2 Droits de l’Utilisateur</strong>
            <br />
            Conformément à la réglementation en vigueur, l’Utilisateur dispose
            d’un droit d’accès, de rectification, d’effacement, de limitation et
            de portabilité sur ses données personnelles. Pour exercer ces
            droits, l’Utilisateur peut contacter l’Éditeur par le biais des
            coordonnées figurant dans les Mentions légales ou en bas des
            présentes CGU.
          </Paragraph>
          <Paragraph>
            <strong>8.3 Cookies</strong>
            <br />
            La Plateforme utilise des cookies et technologies similaires pour
            améliorer l’expérience de navigation de l’Utilisateur. En
            poursuivant sa navigation, l’Utilisateur consent à l’utilisation de
            ces cookies. Il peut toutefois configurer son navigateur pour
            refuser ou effacer ces cookies, au risque de ne pas bénéficier de
            certaines fonctionnalités.
            <br />
            Pour plus d’informations sur l’utilisation des cookies, veuillez
            consulter notre&nbsp;
            <strong>
              <Link to="/legal/data-privacy-policy">Politique de Cookies</Link>
            </strong>
            .
          </Paragraph>

          {/* ARTICLE 9 */}
          <Title level={4}>ARTICLE 9 – RESPONSABILITÉ ET GARANTIE</Title>
          <Paragraph>
            <strong>
              9.1 Accessibilité et fonctionnement de la Plateforme
            </strong>
            <br />
            L’Éditeur met en œuvre les moyens raisonnables pour assurer un accès
            continu et sécurisé à la Plateforme. Toutefois, l’Éditeur ne saurait
            être tenu responsable des indisponibilités ou dysfonctionnements
            imputables à des circonstances extérieures (maintenance, panne
            réseau, cas de force majeure, etc.).
          </Paragraph>
          <Paragraph>
            <strong>9.2 Contenus publiés par les Utilisateurs</strong>
            <br />
            L’Éditeur ne peut être tenu responsable du Contenu publié par les
            Utilisateurs et de ses éventuelles conséquences.
          </Paragraph>
          <Paragraph>
            <strong>9.3 Dommages indirects</strong>
            <br />
            Dans toute la mesure permise par la loi, l’Éditeur ne saurait être
            tenu responsable de tout dommage indirect, prévisible ou non, tels
            que perte de chance, perte de profits, perte de données ou préjudice
            commercial.
          </Paragraph>

          {/* ARTICLE 10 */}
          <Title level={4}>ARTICLE 10 – SUSPENSION ET RÉSILIATION</Title>
          <Paragraph>
            <strong>10.1 Suspension</strong>
            <br />
            En cas de non-respect des présentes CGU, d’atteinte à l’ordre public
            ou aux droits de tiers, l’Éditeur se réserve le droit de suspendre
            sans délai le compte de l’Utilisateur pour effectuer les
            vérifications nécessaires ou prévenir tout dommage éventuel.
          </Paragraph>
          <Paragraph>
            <strong>10.2 Résiliation</strong>
            <br />
            L’Éditeur peut résilier de plein droit le compte de l’Utilisateur en
            cas de manquement grave ou répété aux présentes CGU, sans préavis ni
            indemnité. L’Utilisateur peut également demander la suppression de
            son compte à tout moment en contactant l’Éditeur.
          </Paragraph>

          {/* ARTICLE 11 */}
          <Title level={4}>ARTICLE 11 – MODIFICATION DES SERVICES</Title>
          <Paragraph>
            L’Éditeur se réserve la possibilité de modifier, suspendre ou mettre
            fin à tout ou partie de la Plateforme ou des Services, à sa seule
            discrétion, notamment pour des raisons liées à l’évolution des
            technologies ou à l’adaptation aux règles légales et réglementaires.
            L’Éditeur s’efforcera d’informer l’Utilisateur dans un délai
            raisonnable, dans la mesure du possible.
          </Paragraph>

          {/* ARTICLE 12 */}
          <Title level={4}>ARTICLE 12 – NULLITÉ PARTIELLE</Title>
          <Paragraph>
            Si une ou plusieurs stipulations des présentes CGU sont jugées non
            valides ou déclarées comme telles au regard d’une loi, d’un
            règlement ou d’une décision de justice devenue définitive, les
            autres dispositions garderont toute leur force et leur portée.
          </Paragraph>

          {/* ARTICLE 13 */}
          <Title level={4}>
            ARTICLE 13 – DROIT APPLICABLE ET JURIDICTION COMPÉTENTE
          </Title>
          <Paragraph>
            Les présentes CGU sont soumises au droit français. En cas de litige
            relatif à leur interprétation ou à leur exécution, et après
            tentative de résolution amiable, les tribunaux compétents du ressort
            du siège social de l’Éditeur seront seuls habilités à connaître du
            différend.
          </Paragraph>

          {/* ARTICLE 14 */}
          <Title level={4}>ARTICLE 14 – CONTACT</Title>
          <Paragraph>
            Pour toute question ou réclamation relative aux présentes CGU, aux
            Services ou à la Plateforme, l’Utilisateur est invité à contacter
            l’Éditeur aux coordonnées suivantes :
          </Paragraph>
          <Paragraph>
            <Link to="mailto:support@echow.app">support@echow.app</Link>.
          </Paragraph>

          <Paragraph>
            <strong>
              En utilisant la Plateforme, l’Utilisateur reconnaît avoir lu,
              compris et accepté l’intégralité des présentes CGU.
            </strong>
          </Paragraph>
        </Col>
      </Row>
    </Card>
  )
}

export default CGUPage
